import { Model } from "@bryntum/schedulerpro";
import {HasProjectMixin} from "./mixins/HasProjectMixin.jsx";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";

export class ReminderRecipient extends HasProjectMixin(Model) {
  static get $name() {
    return "ReminderRecipient";
  }

  static relations = {
    userRecord: { // this will get user record of this record
      foreignKey: "boardUserId",
      foreignStore: STORE_KEYS.boardUserStore,
      // this key will be added to the parent to get child records -> userStore.first.reminderRecipients will bring all reminderRecipients records for that user record
      relatedCollectionName: "alertRecipients",
    },
    alertRecord: { // this will get reminder record of this record
      foreignKey: "reminderId",
      foreignStore: STORE_KEYS.reminderStore,
      // this key will be added to the parent to get child records -> reminderStore.first.reminderRecipients will bring all reminderRecipients records for that reminder record
      relatedCollectionName: "alertRecipients",
    },
  }

  static get fields() {
    return [
      { name: "boardUserId", dataSource: "board_user", type: "number" },
      { name: "reminderId", dataSource: "reminder" }, // this is not necessarily be a number as we are adding phantomId of a reminder when creating a board alert
      { name: "boardId", dataSource: "board_id", type: "number" },
      { name: "archived", type: "boolean" },
      { name: "isEmailNotify", dataSource: "is_email_notify"},
      { name: "isWorkforceNotify", dataSource: "is_workforce_notify"},
      { name: "bannerNotify", dataSource: "banner_notify"},
    ];
  }

  get boardUser() {
    return this.project.boardUsersStore.getById(this.boardUserId);
  }
}

ReminderRecipient.exposeProperties();
